import { STATUS_META } from "../lib/api";

export default function StatusBadge({ status }) {
  const meta = STATUS_META[status] || { label: status, className: "bg-muted text-foreground border-border" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border ${meta.className}`}
    >
      {meta.label}
    </span>
  );
}
